module.exports = __webpack_public_path__ + "img/history.bd1fd112.svg";